import { Typography, Box, Paper, Stack } from "@mui/material";
import InstructionItem from "./InstructionItem";
import React, { JSX } from "react";

interface InstructionsProps {
    instructions: {
        text: string;
        component: JSX.Element;
    }[];
    title?: string;
}

const Instructions: React.FC<InstructionsProps> = ({ instructions, title }) => {
    return (
        <Paper elevation={3}>
            <Box p={2}>
                {title && (
                    <Typography variant="h2" gutterBottom>
                        {title}
                    </Typography>
                )}
                <Stack flexGrow={1} display="flex" flexDirection="column" spacing={1} marginRight={5}>
                    {instructions.map((instruction, idx) => (
                        <InstructionItem key={instruction.text} number={idx + 1} numberSize={35}>
                            {instruction.component}
                        </InstructionItem>
                    ))}
                </Stack>
            </Box>
        </Paper>
    );
};

export default Instructions;
